export const twitterConfig = {
	handleName: '@cocoon_space',
	metaImage: {
		url: '/content/space-default',
		width: 1200,
		height: 628,
	},
	pageUrl: 'https://twitter.com/cocoon_space',
} as const
